// Copyright 2005 Jim Radford <radford@blackbean.org> -*- c -*-
// Copyright 2006 David Caldwell <david@porkrind.org>

var ajax = require('./ajax'), loadText=ajax.loadText, makeurl=ajax.makeurl;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var KeyboardFocusAutoPause = require('./keyfocus');
var lib = require('./lib'), nbsp=lib.nbsp, inherit=lib.inherit, map=lib.map;
var dom = require('./dom'), doc=dom.doc, on_load=dom.on_load, URL=dom.URL;
var prnt = require('./print'), print=prnt.print, printf=prnt.printf;
var Prefs = require('./prefs');

class sudoku extends KeyboardFocusAutoPause.mixin(seed_game)  {
    constructor(board_div, welcome_div) {
        super();
        this.div = { board: board_div };
        Prefs.onchange("sudoku.zen-mode", false, (enabled) => {
            this.div.board.classList.set(enabled, "zen-mode");
        });
        this.seed_game_init("sudoku", {game:board_div, welcome:welcome_div});
        // A bold assumption: If we have a mouse then we're a desktop machine and therefore have a keyboard
        // (there's no direct way to detect keyboards yet)
        this.have_keyboard = window.matchMedia("(pointer: fine)").matches;
        if (this.have_keyboard)
             this.init_keyboard_focus_auto_pause(this.div.board);
        this.create();
    }

    from_text(text) {
        text = text.replace(/%[^\n]+\n/, "");
        if (!text.match( /^([\s.\d]{9}\n){9}$/ ))
            return;
        var lines = text.replace(/[ .]/g,nbsp).split("\n");
        for (var r=0; r<9; r++)
            for (var c=0; c<9; c++) {
                this.cell[r][c].state =   lines[r].charAt(c);
                this.cell[r][c].known = !!lines[r].charAt(c).match(/\d/);
            }
    }

    square(sr,sc) {
        return Math.floor(sr/3)*3+Math.floor(sc/3);
    }
    map(type, i, callback) {
        let result = [];
        if (type == "col") for (var r=0; r<9; r++) result.push(callback(this.cell[r][i], r, i)); else
        if (type == "row") for (var c=0; c<9; c++) result.push(callback(this.cell[i][c], i, c)); else
        if (type == "square") { // sr == 0-9, to iterate through all the squares w/out knowing row,column
            var sr = Math.floor(i/3)*3;
            var sc = i%3*3;
            for (var r=0; r<3; r++) for (var c=0; c<3; c++) result.push(callback(this.cell[sr+r][sc+c], sr+r, sc+c));
        }
        if (type == "digit") { // Find all cells that have a particular digit in them (regardless of known/unknown)
            for (let hr=0; hr<9; hr++) for (let hc=0; hc<9; hc++)
                if (this.cell[hr][hc].state == i)
                    result.push(callback(this.cell[hr][hc], hr, hc));
        }

        return result;
    }
    foreach(type, i, callback) { this.map(type, i, callback) } // We could just use map, but this reads better

    is_complete() {
        var axis = ["row", "col", "square"];
        for (var a in axis) {
            for (var i=0; i<9; i++) {
                var digits = this.map(axis[a], i, cell => cell.state);
                if (digits.sort((a,b) => a - b).join("") != "123456789") return NOT_COMPLETE;
            }
        }
        return WON;
    }

    as_string() {
        return [0,1,2,3,4,5,6,7,8].map(r => this.map('row', r, cell => cell.state==nbsp ? '_' : cell.state).join("")).join("");
    }

    end_of_move() {
        this.stats.set("board", this.as_string());
        seed_game.prototype.end_of_move.call(this);
    }

    set_state(old) {
        seed_game.prototype.set_state.call(this, old);
        for (var r=0; r<9; r++) for (var c=0; c<9; c++) {
            this.cell[r][c].state = old.cell[r][c].state;
            this.cell[r][c].known = old.cell[r][c].known;
        }
        this.show_state();
        this.moveto(old.cursor.r, old.cursor.c);
        this.update_keypad();
    }

    get_state() {
        var state = seed_game.prototype.get_state.call(this);
        state.cursor = { r: this.cursor.r, c: this.cursor.c };
        state.cell = this.cell.map(row => row.map(cell => ({
            state: cell.state,
            known: cell.known
        })));
        return state;
    }

    show_state() {
        for (var r=0; r<this.cell.length; r++)
            for (var c=0; c<this.cell[r].length; c++) {
                this.cell[r][c].div.className = r == this.cursor.r && c == this.cursor.c ? "cursor" :
                                                this.cell[r][c].known ? "known" : "unknown";
                this.cell[r][c].text.data = this.cell[r][c].state;
            }
    }

    update_keypad() {
        for (let digit=1; digit<=9; digit++) {
            let count = this.map("digit", digit, ()=>{}).length;
            doc.id(`tp-${digit}`).classList.set(count == 9, "good");
        }
    }

    current() {
        return this.cell[this.cursor.r][this.cursor.c];
    }

    create() {
        this.cell = [];
        for (let r=0; r<9; r++) {
            this.cell[r] = [];
            for (let c=0; c<9; c++) {
                this.cell[r][c] = {};
                this.cell[r][c].erasure = 0;
            }
        }

        const seq = n => Array.from(Array(n)).map((_,i) => i);
        this.control_panel.append(doc(['label', { id: "zen-mode-toggle" },
                                 ['input', { type: "checkbox", checked: Prefs.get('sudoku.zen-mode', false),
                                             onclick: (e) => { Prefs.set('sudoku.zen-mode', e.target.checked) } } ],
                                 "Zen Mode"])),
        doc.clear(this.div.board)
           .append(doc(['div', { className: "game" },
                       ['table', { className: "grid" },
                        ['tbody', seq(9).map(
                                r => ['tr',
                                      seq(9).map(
                                          c => ['td',
                                                ['div', { className: "unknown" },
                                                 nbsp,
                                                 _=>{ this.cell[r][c].div=_;
                                                      this.cell[r][c].text=_.firstChild; },
                                                 { onmousedown: () => {},
                                                   ontouchstart: (e) => e.target.onmousedown(e),
                                                   onclick: () => {
                                                       if (this.cell[r][c].known) { // Clicking on pre-defined number toggles the highlight
                                                           this.highlight(false);
                                                           if (this.cell[r][c].state == this.show)
                                                               this.show = nbsp;
                                                           else
                                                               this.show = this.cell[r][c].state;
                                                           this.highlight(true);
                                                       } else { // clicking into editable cells highlights what's there (but no change if it's blank)
                                                           if (this.cell[r][c].state != nbsp)
                                                               this.show = this.cell[r][c].state;
                                                           this.moveto(r,c);
                                                       }
                                                   },
                                                 }
                                                ]])
                                     ]),
                        ]],
                        ['div', { className: "touchpad" },
                         seq(9).map(n=> ['a', n+1, { id: `tp-${n+1}`, className: "num button", onclick: (ev) => { ev.preventDefault(); this.keypress(n+1) } }]),
                         ['a', "✕", { id: `tp-X`, className: "num button", onclick: (ev) => { ev.preventDefault(); this.keypress(nbsp) } }],
                        ]]));

        this.cursor = { c:0, r:0 };

        if (this.have_keyboard)
          this.register_key_events(event => {
            switch(event.key) {
                case "up":         this.move(-1,  0);     return false;
                case "down":       this.move(+1,  0);     return false;
                case "left":       this.move( 0, -1);     return false;
                case "right":      this.move( 0, +1);     return false;
                case "delete":
                case "backspace":
                case "space":      event.key = nbsp; break;
            }

            let m;
            if (m = event.code.match(/^S-([1-9])$|^escape$/)) {
                this.highlight(false);
                this.show = m[1] ?? nbsp;
                this.highlight(true);
                return false;
            }

            if (!event.key.match(/^[1-9]$/) && event.key != nbsp ||
                event.ctrlKey || event.altKey || event.metaKey)
                return true; // let someone else handle it.

            //this.current().div.className = event.shiftKey ? "pencil" : "unknown";

            this.keypress(event.key);
            return false;
        });
    }

    keypress(digit) {
        this.push_state();
        this.show = digit;
        this.set(digit);
        this.end_of_move();
    }

    highlight(draw) {
        this.current().div.className = draw ? "cursor" : "unknown";

        if (draw) {
            const highlight = (cell, r, c) => this.cell[r][c].div.classList.add("related");
            this.foreach("row",    this.cursor.r,              highlight);
            this.foreach("col",    this.cursor.c,              highlight);
            this.foreach("square", this.square(this.cursor.r,
                                               this.cursor.c), highlight);
            if (this.show != nbsp)
                this.foreach("digit", this.show, (cell, hr, hc) => {
                    cell.div.classList.add("show")
                });
        } else
            for (let hr in this.cell) for (let hc in this.cell[hr])
                this.cell[hr][hc].div.classList.remove("related", "show");
    }

    move(dr, dc) {
        this.highlight(false);
        do {
            this.cursor.r = (this.cursor.r + dr + this.cell   .length) % this.cell   .length;
            this.cursor.c = (this.cursor.c + dc + this.cell[0].length) % this.cell[0].length;
        } while (this.current().known);
        this.highlight(true);
    }

    moveto(r, c) {
        this.highlight(false);
        this.cursor.r = r;
        this.cursor.c = c;
        this.highlight(true);
    }

    set(c) {
        if (this.current().text.data != nbsp &&
            this.current().text.data != c)
            this.current().erasure += this.current().text.className == "pencil" ? 1 : 2;
        this.highlight(false);
        this.current().text.data = this.current().state = c;
        this.highlight(true);
        this.update_keypad();
    }

    on_pause() {
        this.highlight(false);
    }
    on_unpause() {
        this.highlight(true);
    }

    new_game(seed) {
        seed_game.prototype.new_game.call(this,seed);
        this.difficulty = "easy";
        loadText(makeurl("gen","sudoku", { seed: this.seed, difficulty: this.difficulty }), (board, error) => {
            if (board == undefined) {
                printf("Error loading sudoku board: %s\n", error);
                return;
            }
            this.from_text(board);
            this.show = nbsp;
            this.cursor = { r:0, c:0 };
            while (this.current().known)
                this.cursor.c++; // skootch forward to the next non black square.
            this.show_state();
            this.highlight(true);
            this.start_stats();
            if (this.have_keyboard)
                this.input_focus();
        });
    }
}

on_load(() => {
    window.the_game = new sudoku(doc.id("board"), doc.id("welcome"));
    window.the_game.new_game(URL.param.game);
    require('./gotd').start = (game_of_the_day) => { window.the_game.new_game(game_of_the_day) };
});
// Copyright 2005 Jim Radford <radford@blackbean.org> -*- c -*-
// Copyright 2006 David Caldwell <david@porkrind.org>

var ajax = require('./ajax'), loadText=ajax.loadText, makeurl=ajax.makeurl;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var KeyboardFocusAutoPause = require('./keyfocus');
var lib = require('./lib'), nbsp=lib.nbsp, inherit=lib.inherit, map=lib.map;
var dom = require('./dom'), doc=dom.doc, on_load=dom.on_load, URL=dom.URL;
var prnt = require('./print'), print=prnt.print, printf=prnt.printf;
var Prefs = require('./prefs');

class sudoku extends KeyboardFocusAutoPause.mixin(seed_game)  {
    constructor(board_div, welcome_div) {
        super();
        this.div = { board: board_div };
        Prefs.onchange("sudoku.zen-mode", false, (enabled) => {
            this.div.board.classList.set(enabled, "zen-mode");
        });
        this.seed_game_init("sudoku", {game:board_div, welcome:welcome_div});
        // A bold assumption: If we have a mouse then we're a desktop machine and therefore have a keyboard
        // (there's no direct way to detect keyboards yet)
        this.have_keyboard = window.matchMedia("(pointer: fine)").matches;
        if (this.have_keyboard)
             this.init_keyboard_focus_auto_pause(this.div.board);
        this.create();
    }

    from_text(text) {
        text = text.replace(/%[^\n]+\n/, "");
        if (!text.match( /^([\s.\d]{9}\n){9}$/ ))
            return;
        var lines = text.replace(/[ .]/g,nbsp).split("\n");
        for (var r=0; r<9; r++)
            for (var c=0; c<9; c++) {
                this.cell[r][c].state =   lines[r].charAt(c);
                this.cell[r][c].known = !!lines[r].charAt(c).match(/\d/);
            }
    }

    square(sr,sc) {
        return Math.floor(sr/3)*3+Math.floor(sc/3);
    }
    map(type, i, callback) {
        let result = [];
        if (type == "col") for (var r=0; r<9; r++) result.push(callback(this.cell[r][i], r, i)); else
        if (type == "row") for (var c=0; c<9; c++) result.push(callback(this.cell[i][c], i, c)); else
        if (type == "square") { // sr == 0-9, to iterate through all the squares w/out knowing row,column
            var sr = Math.floor(i/3)*3;
            var sc = i%3*3;
            for (var r=0; r<3; r++) for (var c=0; c<3; c++) result.push(callback(this.cell[sr+r][sc+c], sr+r, sc+c));
        }
        if (type == "digit") { // Find all cells that have a particular digit in them (regardless of known/unknown)
            for (let hr=0; hr<9; hr++) for (let hc=0; hc<9; hc++)
                if (this.cell[hr][hc].state == i)
                    result.push(callback(this.cell[hr][hc], hr, hc));
        }

        return result;
    }
    foreach(type, i, callback) { this.map(type, i, callback) } // We could just use map, but this reads better

    is_complete() {
        var axis = ["row", "col", "square"];
        for (var a in axis) {
            for (var i=0; i<9; i++) {
                var digits = this.map(axis[a], i, cell => cell.state);
                if (digits.sort((a,b) => a - b).join("") != "123456789") return NOT_COMPLETE;
            }
        }
        return WON;
    }

    as_string() {
        return [0,1,2,3,4,5,6,7,8].map(r => this.map('row', r, cell => cell.state==nbsp ? '_' : cell.state).join("")).join("");
    }

    end_of_move() {
        this.stats.set("board", this.as_string());
        seed_game.prototype.end_of_move.call(this);
    }

    set_state(old) {
        seed_game.prototype.set_state.call(this, old);
        for (var r=0; r<9; r++) for (var c=0; c<9; c++) {
            this.cell[r][c].state = old.cell[r][c].state;
            this.cell[r][c].known = old.cell[r][c].known;
        }
        this.show_state();
        this.moveto(old.cursor.r, old.cursor.c);
        this.update_keypad();
    }

    get_state() {
        var state = seed_game.prototype.get_state.call(this);
        state.cursor = { r: this.cursor.r, c: this.cursor.c };
        state.cell = this.cell.map(row => row.map(cell => ({
            state: cell.state,
            known: cell.known
        })));
        return state;
    }

    show_state() {
        for (var r=0; r<this.cell.length; r++)
            for (var c=0; c<this.cell[r].length; c++) {
                this.cell[r][c].div.className = r == this.cursor.r && c == this.cursor.c ? "cursor" :
                                                this.cell[r][c].known ? "known" : "unknown";
                this.cell[r][c].text.data = this.cell[r][c].state;
            }
    }

    update_keypad() {
        for (let digit=1; digit<=9; digit++) {
            let count = this.map("digit", digit, ()=>{}).length;
            doc.id(`tp-${digit}`).classList.set(count == 9, "good");
        }
    }

    current() {
        return this.cell[this.cursor.r][this.cursor.c];
    }

    create() {
        this.cell = [];
        for (let r=0; r<9; r++) {
            this.cell[r] = [];
            for (let c=0; c<9; c++) {
                this.cell[r][c] = {};
                this.cell[r][c].erasure = 0;
            }
        }

        const seq = n => Array.from(Array(n)).map((_,i) => i);
        this.control_panel.append(doc(['label', { id: "zen-mode-toggle" },
                                 ['input', { type: "checkbox", checked: Prefs.get('sudoku.zen-mode', false),
                                             onclick: (e) => { Prefs.set('sudoku.zen-mode', e.target.checked) } } ],
                                 "Zen Mode"])),
        doc.clear(this.div.board)
           .append(doc(['div', { className: "game" },
                       ['table', { className: "grid" },
                        ['tbody', seq(9).map(
                                r => ['tr',
                                      seq(9).map(
                                          c => ['td',
                                                ['div', { className: "unknown" },
                                                 nbsp,
                                                 _=>{ this.cell[r][c].div=_;
                                                      this.cell[r][c].text=_.firstChild; },
                                                 { onmousedown: () => {},
                                                   ontouchstart: (e) => e.target.onmousedown(e),
                                                   onclick: () => {
                                                       if (this.cell[r][c].known) { // Clicking on pre-defined number toggles the highlight
                                                           this.highlight(false);
                                                           if (this.cell[r][c].state == this.show)
                                                               this.show = nbsp;
                                                           else
                                                               this.show = this.cell[r][c].state;
                                                           this.highlight(true);
                                                       } else { // clicking into editable cells highlights what's there (but no change if it's blank)
                                                           if (this.cell[r][c].state != nbsp)
                                                               this.show = this.cell[r][c].state;
                                                           this.moveto(r,c);
                                                       }
                                                   },
                                                 }
                                                ]])
                                     ]),
                        ]],
                        ['div', { className: "touchpad" },
                         seq(9).map(n=> ['a', n+1, { id: `tp-${n+1}`, className: "num button", onclick: (ev) => { ev.preventDefault(); this.keypress(n+1) } }]),
                         ['a', "✕", { id: `tp-X`, className: "num button", onclick: (ev) => { ev.preventDefault(); this.keypress(nbsp) } }],
                        ]]));

        this.cursor = { c:0, r:0 };

        if (this.have_keyboard)
          this.register_key_events(event => {
            switch(event.key) {
                case "up":         this.move(-1,  0);     return false;
                case "down":       this.move(+1,  0);     return false;
                case "left":       this.move( 0, -1);     return false;
                case "right":      this.move( 0, +1);     return false;
                case "delete":
                case "backspace":
                case "space":      event.key = nbsp; break;
            }

            let m;
            if (m = event.code.match(/^S-([1-9])$|^escape$/)) {
                this.highlight(false);
                this.show = m[1] ?? nbsp;
                this.highlight(true);
                return false;
            }

            if (!event.key.match(/^[1-9]$/) && event.key != nbsp ||
                event.ctrlKey || event.altKey || event.metaKey)
                return true; // let someone else handle it.

            //this.current().div.className = event.shiftKey ? "pencil" : "unknown";

            this.keypress(event.key);
            return false;
        });
    }

    keypress(digit) {
        this.push_state();
        this.show = digit;
        this.set(digit);
        this.end_of_move();
    }

    highlight(draw) {
        this.current().div.className = draw ? "cursor" : "unknown";

        if (draw) {
            const highlight = (cell, r, c) => this.cell[r][c].div.classList.add("related");
            this.foreach("row",    this.cursor.r,              highlight);
            this.foreach("col",    this.cursor.c,              highlight);
            this.foreach("square", this.square(this.cursor.r,
                                               this.cursor.c), highlight);
            if (this.show != nbsp)
                this.foreach("digit", this.show, (cell, hr, hc) => {
                    cell.div.classList.add("show")
                });
        } else
            for (let hr in this.cell) for (let hc in this.cell[hr])
                this.cell[hr][hc].div.classList.remove("related", "show");
    }

    move(dr, dc) {
        this.highlight(false);
        do {
            this.cursor.r = (this.cursor.r + dr + this.cell   .length) % this.cell   .length;
            this.cursor.c = (this.cursor.c + dc + this.cell[0].length) % this.cell[0].length;
        } while (this.current().known);
        this.highlight(true);
    }

    moveto(r, c) {
        this.highlight(false);
        this.cursor.r = r;
        this.cursor.c = c;
        this.highlight(true);
    }

    set(c) {
        if (this.current().text.data != nbsp &&
            this.current().text.data != c)
            this.current().erasure += this.current().text.className == "pencil" ? 1 : 2;
        this.highlight(false);
        this.current().text.data = this.current().state = c;
        this.highlight(true);
        this.update_keypad();
    }

    on_pause() {
        this.highlight(false);
    }
    on_unpause() {
        this.highlight(true);
    }

    new_game(seed) {
        seed_game.prototype.new_game.call(this,seed);
        this.difficulty = "easy";
        loadText(makeurl("gen","sudoku", { seed: this.seed, difficulty: this.difficulty }), (board, error) => {
            if (board == undefined) {
                printf("Error loading sudoku board: %s\n", error);
                return;
            }
            this.from_text(board);
            this.show = nbsp;
            this.cursor = { r:0, c:0 };
            while (this.current().known)
                this.cursor.c++; // skootch forward to the next non black square.
            this.show_state();
            this.highlight(true);
            this.start_stats();
            if (this.have_keyboard)
                this.input_focus();
        });
    }
}

on_load(() => {
    window.the_game = new sudoku(doc.id("board"), doc.id("welcome"));
    window.the_game.new_game(URL.param.game);
    require('./gotd').start = (game_of_the_day) => { window.the_game.new_game(game_of_the_day) };
});
